"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.dataCyWrapper = exports.dataCyRoleFontIcon = exports.dataCyRoleBadge = exports.dataCy = void 0;
var _react = require("react");
var _Badge = _interopRequireDefault(require("../Badge"));
var _Icon = require("../Icon");
var _Tooltip = _interopRequireDefault(require("../Tooltip"));
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));
var _styles = require("@mui/material/styles");
var _styles2 = require("@mui/styles");
var _clsx3 = _interopRequireDefault(require("clsx"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["children", "icon", "tooltip", "tooltipPlacement", "fontSize", "disabled", "classes", "className", "badge", "badgeColor", "WrapperProps", "active", "edge", "size", "TooltipProps", "crossed", "add"],
  _excluded2 = ["sizeLarge", "sizeSmall", "badge", "active", "wrapper", "crossed"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var dataCy = exports.dataCy = 'IconButton';
var dataCyWrapper = exports.dataCyWrapper = 'IconButtonWrapper';
var dataCyRoleFontIcon = exports.dataCyRoleFontIcon = 'fontIcon';
var dataCyRoleBadge = exports.dataCyRoleBadge = 'dataCyRoleBadge';
var IconButton = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
    icon = _ref.icon,
    tooltip = _ref.tooltip,
    _ref$tooltipPlacement = _ref.tooltipPlacement,
    tooltipPlacement = _ref$tooltipPlacement === void 0 ? 'top' : _ref$tooltipPlacement,
    fontSize = _ref.fontSize,
    disabled = _ref.disabled,
    classes = _ref.classes,
    className = _ref.className,
    badge = _ref.badge,
    _ref$badgeColor = _ref.badgeColor,
    badgeColor = _ref$badgeColor === void 0 ? 'error' : _ref$badgeColor,
    WrapperProps = _ref.WrapperProps,
    active = _ref.active,
    edge = _ref.edge,
    sizeProp = _ref.size,
    TooltipProps = _ref.TooltipProps,
    crossed = _ref.crossed,
    add = _ref.add,
    props = _objectWithoutProperties(_ref, _excluded);
  var sizeLarge = classes.sizeLarge,
    sizeSmall = classes.sizeSmall,
    badgeClass = classes.badge,
    activeClass = classes.active,
    wrapperClass = classes.wrapper,
    crossedClass = classes.crossed,
    otherClasses = _objectWithoutProperties(classes, _excluded2);
  if (typeof icon === 'string') {
    throw new Error("String icon \"".concat(icon, "\" in IconButton is deprecated. Use svg icons directly"));
  }
  if (add) {
    icon = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.AddIcon, {});
  }
  var content = icon ? fontSize ? React.cloneElement(icon, {
    sx: {
      fontSize: fontSize
    }
  }) : icon : children;
  var size = sizeProp;
  if (sizeProp === 'large') {
    size = undefined;
  }
  var dataCyIcon;
  if (icon) {
    var _icon, _icon$replace;
    dataCyIcon = (_icon = icon) === null || _icon === void 0 || (_icon = _icon.type) === null || _icon === void 0 || (_icon = _icon.type) === null || _icon === void 0 || (_icon = _icon.render) === null || _icon === void 0 || (_icon = _icon.displayName) === null || _icon === void 0 || (_icon$replace = _icon.replace) === null || _icon$replace === void 0 ? void 0 : _icon$replace.call(_icon, 'Icon', '');
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip["default"], _objectSpread(_objectSpread({}, TooltipProps), {}, {
    title: tooltip,
    placement: tooltipPlacement,
    arrow: true,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", _objectSpread(_objectSpread({
      ref: ref,
      "data-cy": dataCyWrapper
    }, WrapperProps), {}, {
      className: (0, _clsx3["default"])(wrapperClass, _defineProperty(_defineProperty(_defineProperty({}, classes.edgeStart, edge === 'start'), classes.edgeEnd, edge === 'end'), classes.disabled, disabled), WrapperProps === null || WrapperProps === void 0 ? void 0 : WrapperProps.className),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton["default"], _objectSpread(_objectSpread({
        "data-cy": dataCy,
        "data-cy-icon": dataCyIcon,
        "data-cy-label": tooltip,
        disabled: disabled,
        classes: otherClasses,
        role: 'button',
        className: (0, _clsx3["default"])(className, _defineProperty(_defineProperty(_defineProperty({}, activeClass, active), sizeSmall, size === 'small'), crossedClass, crossed)),
        "data-cy-meta": add ? 'create' : null,
        size: size
      }, props), {}, {
        children: badge ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Badge["default"], {
          badgeContent: badge,
          "data-cy-role": dataCyRoleBadge,
          color: badgeColor
          // classes={{
          //   badge: badgeClass,
          // }}
          ,
          children: content
        }) : content
      }))
    }))
  }));
});
var styles = function styles(theme) {
  return {
    root: {
      padding: 8
    },
    badge: {
      color: 'inherit'
    },
    active: {
      backgroundColor: function backgroundColor(_ref2) {
        var _theme$palette;
        var _ref2$color = _ref2.color,
          color = _ref2$color === void 0 ? 'default' : _ref2$color;
        var palette = (_theme$palette = theme.palette) === null || _theme$palette === void 0 ? void 0 : _theme$palette[color];
        return (0, _styles.alpha)((palette === null || palette === void 0 ? void 0 : palette.main) || theme.palette.action.active, theme.palette.action.selectedOpacity);
      }
    },
    sizeSmall: {
      padding: 3
    },
    /* Styles applied to the root element if `edge="start"`. */
    edgeStart: {
      marginLeft: -8,
      '$sizeSmall&': {
        marginLeft: -3
      }
    },
    /* Styles applied to the root element if `edge="end"`. */
    edgeEnd: {
      marginRight: -8,
      '$sizeSmall&': {
        marginRight: -3
      }
    },
    wrapper: {
      display: 'inline-block'
    },
    disabled: {
      cursor: 'default'
    },
    crossed: {
      '&:before, &:after': {
        content: '""',
        width: '2px',
        height: '26px',
        position: 'absolute',
        transform: 'rotate(-45deg)'
      },
      '&:before': {
        top: '8px',
        left: '17px',
        background: function background(_ref3) {
          var disabled = _ref3.disabled;
          return disabled ? theme.palette.action.disabledBackground : theme.palette.action.active;
        }
      },
      '&:after': {
        top: '6px',
        left: '18px',
        background: theme.palette.background.paper
      },
      '&:hover:after': {
        background: theme.palette.background.paper
      }
    }
  };
};
var _default = exports["default"] = (0, _styles2.withStyles)(styles, {
  name: 'GgIconButton'
})(IconButton);